var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: "icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 1700,
    width: 1024,
    height: 1024,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 156c182.7 0 296.888 197.776 205.536 356L512 868l-205.536-356C215.112 353.776 329.3 156 512 156z",
    fill: "#D5E6F7",
    "p-id": 1702
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M512 156c-8.6 0-17.052 0.44-25.332 1.292 167.66 17.244 267.252 203.936 180.204 354.708l-180.204 312.12L512 868l205.536-356c91.352-158.224-22.836-356-205.536-356z",
    fill: "#A0D1F2",
    "p-id": 1703
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M512 388m-164 0a164 164 0 1 0 328 0 164 164 0 1 0-328 0Z",
    fill: "#FD919F",
    "p-id": 1704
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M512 880a12 12 0 0 1-10.392-6l-205.536-356c-45.068-78.064-45.068-171.268 0-249.332S421.86 144 512 144s170.86 46.604 215.928 124.668 45.068 171.268-0.004 249.332l-205.536 356A11.984 11.984 0 0 1 512 880z m0-712c-81.464 0-154.416 42.116-195.144 112.668-40.732 70.548-40.732 154.784 0 225.332L512 844l195.144-338c40.732-70.548 40.732-154.784 0-225.332C666.416 210.116 593.46 168 512 168z",
    fill: "#504774",
    "p-id": 1705
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M512 564c-97.048 0-176-78.952-176-176s78.952-176 176-176 176 78.952 176 176-78.952 176-176 176z m0-328c-83.812 0-152 68.188-152 152s68.188 152 152 152 152-68.188 152-152-68.188-152-152-152z",
    fill: "#504774",
    "p-id": 1706
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M592.996 293.408c-22.572-21.384-62.876-10.492-76.416-5.976a14.468 14.468 0 0 1-9.16 0c-13.54-4.52-53.844-15.412-76.416 5.976-37.004 32.52-10.84 81.592 2.668 101.86a41.628 41.628 0 0 1 6.912 21.78c1.436 44.884 10.468 87.78 24.332 87.78 15.152 0 16.596-17.316 16.596-55.968 0-18.376 6.892-29.3 14.12-35.7 9.276-8.216 23.456-8.216 32.732 0 7.228 6.404 14.12 17.328 14.12 35.7 0 38.652 1.444 55.968 16.596 55.968 13.864 0 22.9-42.896 24.332-87.78a41.628 41.628 0 0 1 6.912-21.78c13.512-20.268 39.676-69.344 2.672-101.86z",
    fill: "#FFFFFF",
    "p-id": 1707
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M559.084 516.828c-28.596 0-28.596-31.496-28.596-67.968 0-11.804-3.392-20.796-10.08-26.724-4.572-4.048-12.236-4.052-16.82 0.004-6.684 5.92-10.076 14.916-10.076 26.72 0 36.472 0 67.968-28.596 67.968-28.84 0-35.14-62.276-36.328-99.4a29.596 29.596 0 0 0-4.904-15.504c-31.48-47.24-31.752-90.008-0.768-117.392 11.244-10.56 26.64-15.916 45.76-15.916 17.636 0 34.22 4.652 42.536 7.424a2.48 2.48 0 0 0 1.56 0.004c8.328-2.776 24.908-7.428 42.544-7.428 19.124 0 34.52 5.356 45.76 15.916 30.984 27.38 30.712 70.152-0.768 117.388a29.672 29.672 0 0 0-4.908 15.508c-1.176 37.124-7.476 99.4-36.316 99.4zM512 394.996c9 0 17.64 3.256 24.324 9.176 8.284 7.348 18.16 21.06 18.16 44.688 0 12.232 0 36.916 3.364 43.164 4.688-6.924 12.204-32.488 13.576-75.36 0.324-10.08 3.408-19.776 8.92-28.052 14.18-21.28 33.652-60.776 4.732-86.192l-0.332-0.304c-6.652-6.3-16.552-9.496-29.42-9.496-14.248 0-28.008 3.88-34.94 6.192a26.568 26.568 0 0 1-16.768-0.004c-6.92-2.308-20.684-6.188-34.932-6.188-12.872 0-22.772 3.196-29.42 9.496l-0.332 0.304c-28.924 25.416-9.452 64.912 4.732 86.192a53.62 53.62 0 0 1 8.92 28.052c1.372 42.872 8.888 68.432 13.572 75.36 3.364-6.252 3.364-30.932 3.364-43.164 0-23.628 9.876-37.34 18.16-44.684a36.6 36.6 0 0 1 24.32-9.18z",
    fill: "#504774",
    "p-id": 1708
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.312e7e8f57d7f8975a9c86d383245551.svg";
export { ForwardRef as ReactComponent };